import { render, staticRenderFns } from "./BookingHistoryTable.vue?vue&type=template&id=ba7137f6&"
import script from "./BookingHistoryTable.vue?vue&type=script&lang=js&"
export * from "./BookingHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports